
import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
    email: string;
} 

@Component({
    selector: 'project-dialog',
    templateUrl: 'project.dialog.html',
})
export class ProjectDialog {
    constructor(
        public dialogRef: MatDialogRef<ProjectDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
  
    onNoClick(): void {
        this.dialogRef.close();
    }
}